import { Spin } from 'antd';
import React from 'react';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  width: 100%;
  height: calc(100vh - (64rem + 72rem));
  display: grid;
  place-content: center;
`;

const Loader = () => {
  return (
    <LoadingContainer>
      <Spin size="large" />
    </LoadingContainer>
  );
};

export default Loader;
